// Dependecies
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

// Store
import user from '../../store/user';
import dateService from '../../store/dateService';

// Hooks
import useLanguage from '../useLanguage';
import garageWorkShop from '../../store/garageWorkShop';

function useJobRequest(token, routeMaintenanceSchedule) {
  const [userStore] = user();
  const [, actionGarage] = garageWorkShop();
  const [storeDate] = dateService();
  const [reload, useSetReload] = useState(false);
  const [messageError, useSetMessageError] = useState(false);
  const [messagePermission, useSetMessagePermission] = useState(false);
  const [successfully, setSuccessfully] = useState(false);
  const [statusService, useSetStatusService] = useState(0);
  const [dataService, useSetDataService] = useState([]);
  const [dataGarage, useSetDataGarage] = useState([]);
  const [serviceId, useSetServiceId] = useState(0);
  const [garageId, useSetGarageId] = useState(0);
  const [menuToken, useSetMenuToken] = useState(3);
  const [openModalCancel, setOpenModalCancel] = useState(false);
  const [serviceCancelSucces, useSetserviceCancelSucces] = useState(false);
  const [typeService, useSetTypeService] = useState('');
  const [driver, useSetDriver] = useState('');

  const [t] = useTranslation('routers', { useSuspense: false });
  const { locale } = useLanguage();
  const history = useHistory();

  useEffect(() => {
    if (userStore.token) {
      const data = {
        token,
      };
      actionGarage.getTokenService(data, userStore.token).then(
        (res) => {
          if (res) {
            if (res.service !== false) {
              if (res.env === '1') {
                useSetReload(true);
                useSetServiceId(res.service.id);
                useSetDataService(res.service);
                useSetDataGarage(res.garage);
                useSetGarageId(res.garage.id);
                useSetTypeService(res.service_type);
                useSetDriver(res.driver.name);

                if (res.service.id_status !== 1) {
                  const url = `/${locale}/${routeMaintenanceSchedule}`;
                  history.push(url);
                }
              } else {
                useSetMenuToken(4);
                storeDate.dateRequest = moment(res.service.date_service);
                storeDate.hourRequest = res.service.service_hours;
                storeDate.placeRequest = res.service.licenseplate;
                storeDate.descriptionRequest = res.service.description;
                storeDate.cityRequest = res.service.city_id;
                storeDate.userVehicleRequest = res.service.id_user_vehicle;

                const url = `/${locale}/${t('JobRequests')}`;
                history.push(url);
              }
            }
          } else {
            useSetReload(true);
            useSetMessagePermission(true);
          }
        },
        (e) => {
          if (e.status === 404) {
            history.push(`/${locale}/${t('Login')}`);
          }
          if (e.status === 500) {
            useSetReload(false);
            useSetMessageError(true);
          }
        }
      );
    }
  }, [userStore.token]);

  useEffect(() => {
    if (userStore.token && statusService !== 0) {
      const data = {
        id_status: statusService,
        id_service: serviceId,
        id_user_workshop: garageId,
      };
      actionGarage.setService(data, userStore.token, locale).then(
        (res) => {
          if (res) {
            useSetReload(false);
            setOpenModalCancel(false);
            setSuccessfully(true);
            if (statusService === 5) {
              useSetserviceCancelSucces(true);
            }
          }
        },
        (e) => {
          if (e.status === 404) {
            history.push(`/${locale}/${t('Login')}`);
          }
          if (e.status === 500) {
            useSetReload(true);
            useSetMessageError(true);
            setOpenModalCancel(false);
          }
        }
      );
    }
  }, [statusService]);

  const serviceAccept = () => {
    useSetStatusService(2);
    setOpenModalCancel(false);
  };

  const serviceCancel = () => {
    setOpenModalCancel(true);
  };

  const closeModal = () => {
    setOpenModalCancel(false);
  };

  function confirmationServiceCancel() {
    useSetStatusService(5);
  }

  return {
    reload,
    messageError,
    setSuccessfully,
    successfully,
    dataService,
    dataGarage,
    closeModal,
    openModalCancel,
    serviceCancelSucces,
    serviceAccept,
    serviceCancel,
    confirmationServiceCancel,
    menuToken,
    messagePermission,
    typeService,
    driver,
  };
}

export default useJobRequest;
